import { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import { Button, Grid, TextField } from '@material-ui/core';
import { handleSnackBar, setReRender, invokePostService, setFocusElement, toggleRightDrawer } from '../../../store/global/actions';
import { useDispatch } from 'react-redux';
import { useHistory } from "react-router-dom";
import { getDetailsFromUrl } from '../../../services/blueprint'
import { basic, validationMessages } from '../../../config/validations';
import { validateNonAsciiChars } from '../../../utils/commonUtils';



export default function CreateTestsuite({ onClose}) {

    const dispatch = useDispatch();
    const history = useHistory();
    const { register,control, handleSubmit, formState: { errors }, watch, setValue, reset, setError } = useForm();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        
    }, []);

    const messages = {
        ...validationMessages,
    }

    const onCreateTestsuite = async ({ name, description }) => {
       
        const testsuite = {
            name,
            description: description != undefined ? description : "",
            context: []
        }
        setLoading(true);
        dispatch(invokePostService('createTestsuite',{testsuite})).then(response => {
            setLoading(true);
            console.log({response})
            if (response.status && response.data !== null) {
                const { slug, blueprintId } = getDetailsFromUrl();
                history.push(`/blueprint/${slug}/${blueprintId}/testsuite/${response.data?._id}`);
                dispatch(toggleRightDrawer());
                dispatch(setFocusElement({}));
                dispatch(handleSnackBar({ open: true, message: response.message, severity: 'success' }));
                dispatch(setReRender());
            } else {
                if (response?.code === process.env.REACT_APP_FORM_ERROR_CODE) {
                    response?.errors?.forEach(error => {
                        setError(error.name, { message: error.message });
                    });
                } else if (response?.message) {
                    dispatch(handleSnackBar({ open: true, message: response.message, severity: 'error' }))
                }
                setLoading(false);
            }
        });
        
    }


    console.log({errors});

    return (
        <Grid container direction={"row"} spacing={3}>

            {/* {tabActive == 'simulationInfo' &&
                <>
                </>
            } */}
            <Grid item xs={12}>
                <TextField
                    name="name"
                    autoFocus
                    fullWidth
                    type={"text"}
                    required={true}
                    label={"Name"}
                    placeholder={""}
                    variant="outlined"
                    inputRef={register({ ...basic })}
                    error={errors?.name ? true : false}
                    helperText={errors?.name ? errors?.name?.message ? errors.name.message : messages[errors?.name?.type] : ''}
                />
            </Grid>

            <Grid item xs={12}>
                <TextField
                    type={"text"}
                    fullWidth
                    multiline={true}
                    rows={4}
                    label={"Description"}
                    variant="outlined"
                    name="description"
                    inputRef={register({ required: false, validate: validateNonAsciiChars})}
                    error={errors?.description}
                    helperText={errors?.description?.message || ''}
                />
            </Grid>

            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button onClick={onClose} color="primary" variant="outlined" style={{ marginLeft: 10 }}>
                    Cancel
                </Button>
                <Button disabled={loading} onClick={handleSubmit(onCreateTestsuite)} color="primary" variant="contained" style={{ marginLeft: 10 }}>
                    {loading ? 'Creating..' : 'Create'}
                </Button>
            </Grid>

        </Grid >
    )
}